import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IntegrationStatusService } from 'src/app/services/integration-status.service';

@Component({
  selector: 'app-integration-status-organism',
  templateUrl: './integration-status-organism.component.html',
  styleUrls: ['./integration-status-organism.component.scss']
})
export class IntegrationStatusOrganismComponent implements OnInit {

  data:any[] = [];
  dynamicHeaders:any[] = [];
  tableDataFetched:boolean = false;

  constructor(private integrationService:IntegrationStatusService, private snack: MatSnackBar,){}

  ngOnInit(): void {
    this.getIntegrationStatus();
    this.dynamicHeaders = [
      {field: 'facility', headerText: 'Facility', allowFiltering: false, width:'200px'},
      {field: 'integration_type', headerText: 'Type', allowFiltering: false, width:'200px'},
      {field: 'last_integrated_date', headerText: 'Recent Inbound Date', allowFiltering: false, width:'200px'},
      {field: 'source', headerText: 'Source', allowFiltering: false, width:'200px'},
    ]
  }
    showSnackbar(message: string) {
    this.snack.open(message, 'close', {
      duration: 4000,
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }
  getIntegrationStatus(){
    this.integrationService.getStatus().subscribe((response:any)=>{
      this.data = response;
      this.tableDataFetched = true;
    },(error)=>{
      this.showSnackbar('Error while fetching status');
      this.tableDataFetched = false;
    })
  }
}
